export const clonePrices = [
  {
    resource: 'mks_cluster_regional',
    group: 'ru-1',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_regional',
    group: 'ru-2',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_regional',
    group: 'ru-3',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_regional',
    group: 'ru-7',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_regional',
    group: 'ru-8',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_regional',
    group: 'ru-9',
    name: {
      ru: 'Кластер Managed Kubernetes. Региональный - 3 мастер ноды',
      en: 'Managed Kubernetes Cluster. Regional with 3 master nodes'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-1',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-2',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-3',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-7',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-8',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  },
  {
    resource: 'mks_cluster_zonal',
    group: 'ru-9',
    name: {
      ru: 'Кластер Managed Kubernetes. Зональный - 1 мастер нода',
      en: 'Managed Kubernetes Cluster. Zonal with 1 master node'
    }
  }
]